import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useRecordContext } from "ra-core";
import useTierInfo from "../../../hooks/useTierInfo";
const useStyles = makeStyles(() => ({
  container: {
    marginTop: 10,
    marginBottom: 15,
  },
}));

const TierConditionField = (props) => {
  const classes = useStyles();
  const record = useRecordContext(props);
  const { loading, tier, error } = useTierInfo(record.id);

  if (loading) return null;
  if (error) {
    return null;
  }

  return (
    <>
      <Typography variant="h4"> Tier Condition </Typography>
      <Table className={classes.container}>
        <TableHead>
          <TableCell>Condition Name</TableCell>
          <TableCell>Value</TableCell>
        </TableHead>

        <TableRow>
          <TableCell>{tier.condition?.getMessage()}</TableCell>
          <TableCell>{record.conditions[0].value}</TableCell>
        </TableRow>
      </Table>
    </>
  );
};

export default TierConditionField;
